<fury-list [hideSearchInput]="true">
    <div class="table">
      <table mat-table [dataSource]="dataSource">
        
        <ng-container *ngFor="let time of displayedColumns" [matColumnDef]="time">
          <th mat-header-cell *matHeaderCellDef>{{time}}</th>
          <td mat-cell *matCellDef="let element" (click)="handleScheduleClick(time, getScheduleDate(element, time), element)"
          [class.selectedCell]="selectedSchedule.has(time)"  [class.availableCell]="getScheduleDate(element, time)">
          </td>
        </ng-container>
         
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

    </div>
  </fury-list>
  